import { createContext } from "react";

const SessionsContext = createContext();

export default SessionsContext;
